import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDxnWGHKaNlC6mgz9Mn3UdSVcRaBo9brT4",
    libraries: "places" // necessary for places input
  }
});

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
